import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import intlArrayHelper from 'common/language/intlArrayHelper';
import { getWhdStatementByName } from 'common/supportingDocuments/whdStatements';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const EvidentiaryDocs = ({ supportingDocType, handleChange, intl }) => {
  const documentTypes = intlArrayHelper('supportingDocuments.documentType.items');
  const evidentiaryDocumentTypes = documentTypes
    ?.filter(docType => !getWhdStatementByName(docType.value));

  return (<select value={ supportingDocType } onChange={ e => handleChange(e) } aria-label={ intl.formatMessage({ id: 'supportingDocuments.dropdown.title' }) }>
    <option value="" disabled><LocalisedMessage id="supportingDocuments.documentType.placeholder" /></option>
    { evidentiaryDocumentTypes.map(item => <option key={ item.value } value={ item.value }>{ item.label }</option>) }
  </select>);
};

EvidentiaryDocs.propTypes = {
  supportingDocType: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
};

export default injectIntl(EvidentiaryDocs);
